export const isAllSubCatalogProductsEmpty = (catalogSubCatalogs) => {
    const subCatalogsList = catalogSubCatalogs?.subCatalogs
        ? Object.values(catalogSubCatalogs?.subCatalogs)
        : [];

    if (!subCatalogsList?.length) return true;

    return  subCatalogsList.every(subCatalog => {
        const productGroupsList = !!subCatalog?.productGroups
            ? Object.values(subCatalog.productGroups)
            : []

        return productGroupsList.every(productGroup => !productGroup?.products?.length)
    })
}